module.exports = __webpack_public_path__ + "img/Ariel.c399734a.jpg";